module.exports = __webpack_public_path__ + "img/smsBlack.54aca6c1.gif";